'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

require('../enums/accordion.js');
require('../enums/alert.js');
require('../enums/avatar.js');
require('../enums/breakpoints.js');
require('../enums/button.js');
require('../enums/code-editor.js');
var colors = require('../enums/colors.js');
require('../enums/combobox.js');
require('../enums/date.js');
require('../enums/drag-and-drop.js');
require('../enums/dialog.js');
require('../enums/divider.js');
require('../enums/dropdown.js');
require('../enums/fieldset.js');
require('../enums/font-icon.js');
require('../enums/fonts.js');
require('../enums/headings.js');
require('../enums/input.js');
require('../enums/keys.js');
require('../enums/list.js');
require('../enums/listbox.js');
require('../enums/loader.js');
require('../enums/margin.js');
require('../enums/option.js');
require('../enums/pill.js');
require('../enums/placements.js');
require('../enums/popout.js');
require('../enums/privacy.js');
require('../enums/radio-group.js');
require('../enums/status.js');
require('../enums/switch.js');
require('../enums/table.js');
require('../enums/tooltip.js');
require('../enums/transitions.js');
require('../enums/widths.js');
var colors$1 = require('./colors.js');

const textButtonBorderTransparent = {
    borderColor: 'transparent',
    borderColorActive: 'transparent',
    borderColorDisabled: 'transparent',
    borderColorFocus: 'transparent',
    borderColorHover: 'transparent'
};
const blackButton = {
    backgroundColor: 'transparent',
    backgroundColorActive: '#F9FBFC',
    backgroundColorDisabled: 'transparent',
    backgroundColorFocus: '#F1F5FA',
    backgroundColorHover: '#F1F5FA',
    outlineColorFocus: '#6f6f6f',
    textColor: colors.BrandfolderHexColors.Text,
    textColorActive: '#9B9B9B',
    textColorFocus: '#6f6f6f',
    textColorHover: '#6f6f6f',
    textColorDisabled: '#BCBCBC',
    ...textButtonBorderTransparent
};
const dangerButton = {
    backgroundColor: colors.BrandfolderHexColors.Delete,
    backgroundColorActive: '#000000',
    backgroundColorDisabled: '#F5F5F5',
    backgroundColorFocus: colors.BrandfolderHexColors.Delete,
    backgroundColorHover: '#B30016',
    borderColor: colors.BrandfolderHexColors.Delete,
    borderColorActive: '#000000',
    borderColorDisabled: '#F5F5F5',
    borderColorFocus: colors.BrandfolderHexColors.Delete,
    borderColorHover: '#B30016',
    outlineColorFocus: colors.BrandfolderHexColors.Delete,
    textColor: '#FFFFFF',
    textColorActive: '#FFFFFF',
    textColorFocus: '#FFFFFF',
    textColorHover: '#FFFFFF',
    textColorDisabled: '#BCBCBC'
};
const primaryButton = {
    backgroundColor: colors$1.brandfolderColorPalette.primary[700],
    backgroundColorActive: colors$1.brandfolderColorPalette.primary[900],
    backgroundColorDisabled: colors$1.brandfolderColorPalette.neutrals[100],
    backgroundColorFocus: colors$1.brandfolderColorPalette.primary[700],
    backgroundColorHover: colors$1.brandfolderColorPalette.primary[800],
    borderColor: colors$1.brandfolderColorPalette.primary[700],
    borderColorActive: colors$1.brandfolderColorPalette.primary[900],
    borderColorDisabled: colors$1.brandfolderColorPalette.neutrals[100],
    borderColorFocus: colors$1.brandfolderColorPalette.primary[700],
    borderColorHover: colors$1.brandfolderColorPalette.primary[800],
    outlineColorFocus: colors$1.brandfolderColorPalette.primary[700],
    textColor: colors$1.brandfolderColorPalette.neutrals[0],
    textColorActive: colors$1.brandfolderColorPalette.neutrals[0],
    textColorFocus: colors$1.brandfolderColorPalette.neutrals[0],
    textColorHover: colors$1.brandfolderColorPalette.neutrals[0],
    textColorDisabled: colors$1.brandfolderColorPalette.neutrals[400]
};
const secondaryButton = {
    backgroundColor: '#FFFFFF',
    backgroundColorActive: '#F1F5FA',
    backgroundColorDisabled: '#FFFFFF',
    backgroundColorFocus: '#FFFFFF',
    backgroundColorHover: '#F1F5FA',
    borderColor: '#4462C9',
    borderColorActive: '#4A4A4A',
    borderColorDisabled: '#BCBCBC',
    borderColorFocus: '#4462C9',
    borderColorHover: '#4462C9',
    outlineColorFocus: '#4462C9',
    textColor: '#4462C9',
    textColorActive: '#4A4A4A',
    textColorFocus: '#4462C9',
    textColorHover: '#4462C9',
    textColorDisabled: '#BCBCBC'
};
const tertiaryButton = {
    backgroundColor: '#FFFFFF',
    backgroundColorActive: '#F1F5FA',
    backgroundColorDisabled: '#FFFFFF',
    backgroundColorFocus: '#FFFFFF',
    backgroundColorHover: '#F1F5FA',
    borderColor: '#E2E2E2',
    borderColorActive: '#4A4A4A',
    borderColorDisabled: '#BCBCBC',
    borderColorFocus: '#9EAFE2',
    borderColorHover: '#4462C9',
    outlineColorFocus: '#4462C9',
    textColor: '#4A4A4A',
    textColorActive: '#4A4A4A',
    textColorFocus: '#4A4A4A',
    textColorHover: '#4462C9',
    textColorDisabled: '#BCBCBC'
};
const warningButton = {
    backgroundColor: '#FFFFFF',
    backgroundColorActive: '#000000',
    backgroundColorDisabled: '#F5F5F5',
    backgroundColorFocus: colors.BrandfolderHexColors.Delete,
    backgroundColorHover: '#B30016',
    borderColor: colors.BrandfolderHexColors.Delete,
    borderColorActive: '#000000',
    borderColorDisabled: '#F5F5F5',
    borderColorFocus: colors.BrandfolderHexColors.Delete,
    borderColorHover: '#B30016',
    outlineColorFocus: colors.BrandfolderHexColors.Delete,
    textColor: colors.BrandfolderHexColors.Delete,
    textColorActive: '#FFFFFF',
    textColorFocus: '#FFFFFF',
    textColorHover: '#FFFFFF',
    textColorDisabled: '#BCBCBC'
};
const whiteButton = {
    backgroundColor: 'transparent',
    backgroundColorActive: 'transparent',
    backgroundColorDisabled: 'transparent',
    backgroundColorFocus: 'transparent',
    backgroundColorHover: 'transparent',
    outlineColorFocus: '#E6E6E6',
    textColor: '#fff',
    textColorActive: '#CBCBCB',
    textColorFocus: '#E6E6E6',
    textColorHover: '#E6E6E6',
    textColorDisabled: '#BCBCBC',
    ...textButtonBorderTransparent
};
const textSecondaryButton = {
    ...secondaryButton,
    ...textButtonBorderTransparent
};
const textTertiaryButton = {
    ...tertiaryButton,
    ...textButtonBorderTransparent
};
const textWarningButton = {
    ...warningButton,
    ...textButtonBorderTransparent
};

exports.blackButton = blackButton;
exports.dangerButton = dangerButton;
exports.primaryButton = primaryButton;
exports.secondaryButton = secondaryButton;
exports.tertiaryButton = tertiaryButton;
exports.textSecondaryButton = textSecondaryButton;
exports.textTertiaryButton = textTertiaryButton;
exports.textWarningButton = textWarningButton;
exports.warningButton = warningButton;
exports.whiteButton = whiteButton;
//# sourceMappingURL=button.js.map
